// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { setSitesData } from 'redux/modules/rfDroneServices/actions'
import { fetchWrapper } from 'helpers/api'

const getSitesData = (project) => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const { sites } = getState().rfDroneServices

      // if the data isn't expired yet, and project hasn't changed, just return what we have in redux store.
      if (sites.dataExpiration > Date.now() && sites.projectId === project && sites.data.length) {
        return sites.data
      }

      try {
        const data = await fetchWrapper(`/rfDroneProjects/${project}`)
        const sitesData = data.sites.map(site => ({
          id: site.siteName,
          model: site.modelFolderURI || false,
          pano: site.panoFolderURI || false,
          panoExt: site.panoExtension || false,
          zoomVideo: site.zoomVideoFileURI || false,
          pathVideo: site.pathVideoFileURI || false,
          designOverlay: site.designOverlayFileURI || false,
        }))

        dispatch(setSitesData(sitesData, project))
        return sitesData
      } catch (err) {
        console.warn(err)
        return []
      }
    })
  )
)

export default getSitesData
